module.exports = __webpack_public_path__ + "static/img/photo-forest-01.0bb083f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-forest-01.jpg
// module id = FnMM
// module chunks = 1